import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';
import React, { useState, useEffect } from 'react';

const ModalWrapper = styled(animated.div)`
    background-color: rgba(0,0,0,0.5);
    width: 100%; height: 100%;
    justify-content: center;
    align-items: center;
    top: 0; left: 0;
    position: fixed;
    display: flex;
    z-index: 2;
`;

const ModalContent = styled.div`
    position: relative;
    width: 70vw;
    max-width: 600px;
    height: auto;
    background-color: white;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.5);
    z-index: 3;

    @media (max-width: 480px) {
        width: 80vw;
    }
`;

const Modal = ({ isOpen, onClose, children }) => {
    const [displayContent, setDisplayContent] = useState(isOpen);

    const backgroundFade = useSpring({
        config: {
            tension: 150,
            friction: 20
        },
        opacity: isOpen ? 1 : 0,
        onRest: () => setDisplayContent(isOpen)
    });

    useEffect(() => {
        if (isOpen) { setDisplayContent(true); }
    }, [isOpen]);

    if (!displayContent) { return null; }

    return (
        <ModalWrapper style={backgroundFade} onClick={onClose}>
            <ModalContent onClick={(e) => e.stopPropagation()} >
                {children}
            </ModalContent>
        </ModalWrapper>
    );
};

export default Modal;